var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-head-wrap"},[_c('login-header')],1),_c('div',{staticClass:"login-content"},[_c('div',{ref:"backgroundWrap",staticClass:"background-wrap"}),_c('transition',{attrs:{"name":"default","mode":"out-in"}},[_c(_vm.handleType,{tag:"component",staticClass:"handle-component"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }